import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsDashboardsFilterSelectionConfigurationsBulkUpdateProcessMutation() {
  return useMutation({
    mutationFn: async ({ bulkUpdateProcessParams, divisionId }) => {
      fetch(
        `/companies/${divisionId}/projects_dashboards/filter_selection_configurations/bulk_update_processes`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            authenticity_token: (
              document.querySelector('meta[name="csrf-token"]') || {}
            ).content,
            bulk_update_process: bulkUpdateProcessParams,
          }),
          keepalive: true,
        },
      );
    },
  });
}
